import heart from '@/assets/images/icon_sm.png';
import '@/components/General/Loading.scss';

const Loading = ({ size = null }) => {
  return (
    <div
      className="loading-wrapper"
      style={{
        padding: size ? `${size / 4}px` : '2rem',
      }}
    >
      <img
        src={heart}
        alt="Loading"
        className="loading-heart"
        style={{
          width: size ? `${size}px` : '64px',
        }}
      />
    </div>
  );
};

export default Loading;
